let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5JaWK")).then(() => parcelRequire('gsb5f'));